import React from 'react'
import { triggerClickOnCanvas } from 'helpers/triggerClickOnCanvas'
import { StyledAnswerButtonTransparent as S } from './AnswerButtonTransparent.styles'

type TProps = {
  children?: React.ReactNode
}

export const AnswerButtonTransparent: React.FC<TProps> = ({ children }) => {
  return <S.Content onClick={triggerClickOnCanvas}>{children}</S.Content>
}
